import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConditionSheetComponent } from '@ui/pages/conditions-page/condition-sheet/condition-sheet.component';

@Component({
  selector: 'app-conditions-page',
  standalone: true,
  imports: [CommonModule, ConditionSheetComponent],
  templateUrl: './conditions-page.component.html',
  styleUrl: './conditions-page.component.scss',
})
export class ConditionsPageComponent {}
